
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import VerticalTabs from 'components/VerticalTabs'
import {connect} from 'react-redux'
import MappedView from './MappedView'
import UnMappedView from './UnMappedView'
import CampaignFieldView from './CampaignFieldView'

const tabs = [
  {
    key: 'unmapped',
    label: 'Unmapped',
    component: UnMappedView,
    to: `/settings/custom-mapping/unmapped`
  },
  {
    key: 'mapped',
    label: 'Mapped',
    component: MappedView,
    to: `/settings/custom-mapping/mapped`
  },
  {
    key: 'campaign',
    label: 'Campaign',
    component: CampaignFieldView,
    to: `/settings/custom-mapping/campaign`
  }
]

export class SettingCustomMappingView extends React.Component {
  static propTypes = {
    type: PropTypes.string
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  render() {
    const {type} = this.props
    const Component = tabs.find(item => item.key === type).component

    return (
      <div className='settings-custom-mapping-view container'>
        <div className='settings-custom-mapping-view_menu'>
          <VerticalTabs items={tabs} activeItemId={type} />
        </div>
        <div className='settings-custom-mapping-view_mappings'>
          <Component key={type} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, {params: {type}}) => ({
  type
})

export default connect(mapStateToProps, {})(SettingCustomMappingView)



// WEBPACK FOOTER //
// ./client/views/SettingsCustomMappingView/index.js